import { TextField, Tooltip } from "@mui/material";

export default function QuickNoteEditCell({ params, isEdit }: any) {
  return (
    <>
      {isEdit ? (
        <TextField
          sx={{
            width: "100%",
            height: 40,
            padding: 0,
            my: 0.75,
            "& .MuiOutlinedInput-input": {
              padding: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          }}
          variant="outlined"
          value={params.value ?? ""}
          onChange={(event) => {
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: event.target.value,
            });
          }}
          autoFocus
        />
      ) : (
        <Tooltip title="Please double click or press Enter to modify.">
          <TextField
            sx={{
              width: "100%",
              height: 40,
              padding: 0,
              my: 0.75,
              "& .MuiOutlinedInput-input": {
                padding: 1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              "& input": {
                caretColor: "transparent",
              },
            }}
            variant="outlined"
            value={params.value ?? ""}
            onChange={(event) => {
              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: event.target.value,
              });
            }}
          />
        </Tooltip>
      )}
    </>
  );
}
